import { Component, ComponentRef, Type, ViewChild, ViewContainerRef, effect, signal, Input, computed, inject, ChangeDetectionStrategy } from '@angular/core';

import { IEntityMetaData } from '@app/common-codes/_models/IEntityMetaData';
import { GenericListComponent } from '@app/common-codes/components/list-components/generic-base-list/generic-list.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { TabComponentLoader } from '@app/common-codes/services/TabComponentLoader.service';
import { ListTableColumnComponent } from '@app/common-codes/components/list-components/list-table-column/list-table-column.component';
import { ListViewComponent } from '@app/common-codes/components/list-components/list-view/list-view.component';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { MatwinsVariablesService } from '@app/common-codes/services/matwinsVariables.service';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { Dock } from '@app/common-codes/models/matwins-tenant/Dock.model';
import { DockDetailComponent } from '../dock-detail/dock-detail.component';
import { LookupProfile, LookupService, LookupItem } from '@app/common-codes/services/LookupService';
import { ReactiveBadgeComponent } from '@app/common-codes/components/nested-components/reactive-badge/reactive-badge.component';

@Register(Dock)
@Component({
  selector: 'app-dock-list',
  templateUrl: './dock-list.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ListViewComponent,
    DockDetailComponent,
    ListTableColumnComponent,
    TranslatePipe,
    ReactiveBadgeComponent
]
})
export class DockListComponent extends GenericListComponent<Dock> {

  override Skin = MatwinsSkins.V1 as IStaticStylesConfig;
  override ComponentEntityClass = Dock;
  override entityMetaData: IEntityMetaData = new Dock().GetType();
  private loadedComponents: { [key: string]: ComponentRef<any> } = {};
  override contextMenuItems = [];
  // isModalOpen = signal(false);
  modalEntity = signal<Dock | null>(null);
  @ViewChild('dockDetail', { read: DockDetailComponent }) dockDetail!: DockDetailComponent;
  dockStatusLookup = signal<LookupItem[]>([]);

  constructor(private tabLoader: TabComponentLoader, _alertModalService: AlertModalService, translationService: TranslationService) {
    super();
    this.alertModalService = _alertModalService;

    effect(() => {
      const entities = this.listView()?.entities();
      if (entities) {
        // Lire la revision : si les listes arrivent en retard, l'effet repasse et les remplit.
        this.lookupService.revision();
        this.dockStatusLookup.set(this.lookupService.getLookupData('DockStatus'));
      }
    });
  }

  onSearchInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.searchTerm.set(value);
    this.listView()?.onSearch(value);
  }

  public static override get lookupProfiles(): LookupProfile[] {
    const lookupProfiles: LookupProfile[] = [
      {
        lookupName: "DockStatus",
      }
    ];
    return lookupProfiles;
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  override getdetailComponent(): GenetricDetailComponent<Dock> | undefined {
    return this.dockDetail;
  }

}

